import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ChangePassword from "./ChangePassword";
import EditProfile from "./EditProfile";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, smScreen, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            padding: smScreen ? "0 8px 16px 8px" : "0 2.5% 16px",
            height: {
              xs: "calc(100vh - 145px)",
              md: "calc(100vh - 160px)",
              xl: "calc(100vh - 175px)",
            },
            overflowY: "auto",
          }}
          className="setting-right"
        >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function SettingsMain({ collapse }) {
  const [value, setValue] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        display: isMobile ? "block" : "flex",
      }}
      className={`custom-vertical-tab-box ${collapse ? "collapse-tabs" : ""}`}
    >
      {/* {loading && <Spinner />} */}
      <Tabs
        orientation={isMobile ? "horizontal" : "vertical"}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{
          width: smScreen ? "100%" : "180px",
          minWidth: smScreen ? "100%" : "180px",
          borderRight: 1,
          borderColor: {
            xs: 'transparent',
            sm: "rgba(3, 41, 58, 0.20)", md: "rgba(3, 41, 58, 0.20)",
            lg: "rgba(3, 41, 58, 0.20)",
            xl: "rgba(3, 41, 58, 0.20)"
          },
          marginBottom: {
            xs: '15px',
            sm: 0,
            md: 0,
            lg: 0,
            xl: 0
          },
        }}
      >
        <Tab
          label={
            <Box
              display={"flex"}
              alignItems={"center"}
              width={"100%"}
              textAlign="right"
            >
              <Typography
                variant={"span"}
                component={"span"}
              >
                View Profile
              </Typography>
            </Box>
          }
          {...a11yProps(0)}
          sx={{ paddingLeft: 0, "&.Mui-selected": { color: '#0832DE !important' } }}
        />
        <Tab
          label={
            <Box
              display={"flex"}
              alignItems={"center"}
              width={"100%"}
              textAlign="right"
            >
              <Typography
                variant={"span"}
                component={"span"}
              >
                Change Password
              </Typography>
            </Box>
          }
          {...a11yProps(1)}
          sx={{ paddingLeft: 0, "&.Mui-selected": { color: '#0832DE !important' } }}
        />
      </Tabs>
      <TabPanel style={{ width: "100%" }} value={value} index={0} smScreen={smScreen}>
        <EditProfile smScreen={smScreen} />
      </TabPanel>
      <TabPanel style={{ width: "100%" }} value={value} index={1} smScreen={smScreen}>
        <ChangePassword />
      </TabPanel>
    </Box>
  );
}
